export default "__VITE_ASSET__Oy1GqP_i__"